import Model from "@/models/common.js";
import moment from "moment";
import api from "@/api/medsenger_api.js";
import {timestamp} from "@/helpers/helpers.js";

class ConversationMessage extends Model {
    constructor(description) {
        super(description);
    }

    init(description) {
        super.init(description);
        this.isDoctorMessage = this.author_type === 'doctor';
        this.author_role = this.author_role || (this.author_type === 'registrator' ? 'Администратор' : 'Врач');
        this.is_agent = false;
        this.author_photo_user_id = this.author_type === 'registrator' ? null : this.author_user_id;
        this.notified_doctor_helpers = this.notified_doctor_helpers || [];
        this.attachments = this.attachments || [];
        this.images = this.images || [];

        if (this.can_be_deleted) {
            const deletionInterval = (this.sent_timestamp + 180 - timestamp()) * 1000;
            if (deletionInterval > 0) {
                setTimeout(() => this.markAsCannotBeDeleted(), deletionInterval);
            } else {
                this.markAsCannotBeDeleted();
            }
        }
    }

    sentDate() {
        if (!this.sent_timestamp) return '';
        return moment(this.sent_timestamp * 1000).format('DD.MM.YYYY');
    }

    sentTime() {
        if (!this.sent_timestamp) return '';
        return moment(this.sent_timestamp * 1000).format('HH:mm');
    }

    markAsCannotBeDeleted() {
        this.can_be_deleted = false;
        this.refreshDB();
    }

    isActual() {
        return !this.is_deleted;
    }

    isVoiceMessage() {
        return (this.text === 'Голосовое сообщение' || this.is_audio_message) && this.attachments?.[0];
    }

    type() {
        return 'conversation_messages';
    }

    async delete() {
        await api.conversations.deleteMessage(this.id);
        this.is_deleted = true;
        this.refreshDB();
    }
}

export default ConversationMessage
